import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ToasterIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ToasterIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M22.0771 15.5035H20.9701V8.3534C20.9701 8.14345 20.7999 7.97326 20.59 7.97326H20.2098V7.33289C20.2098 6.2652 19.3443 5.39966 18.2766 5.39966H14.3321C13.2643 5.39966 12.3988 6.26522 12.3988 7.33293V7.97326H11.1943V7.33289C11.1943 6.2652 10.3288 5.39966 9.26111 5.39966H5.31661C4.24889 5.39966 3.38334 6.26521 3.38334 7.33293V7.97326H3.00319C2.79324 7.97326 2.62305 8.14346 2.62305 8.3534V19.1199C2.62305 19.3299 2.79325 19.5001 3.00319 19.5001H20.59C20.7999 19.5001 20.9701 19.3299 20.9701 19.1199V16.6687H22.0771C22.2871 16.6687 22.4572 16.4985 22.4572 16.2886V15.8837C22.4572 15.6737 22.287 15.5035 22.0771 15.5035ZM13.564 7.33289C13.564 6.90871 13.9078 6.56485 14.332 6.56485H18.2765C18.7007 6.56485 19.0446 6.90873 19.0446 7.33293V7.59312C19.0446 7.80307 18.8744 7.97326 18.6645 7.97326H13.9441C13.7342 7.97326 13.564 7.80306 13.564 7.59312L13.564 7.33289ZM4.54857 7.33289C4.54857 6.90871 4.89243 6.56485 5.31661 6.56485H9.26111C9.68531 6.56485 10.0292 6.90873 10.0292 7.33293V7.59312C10.0292 7.80307 9.85899 7.97326 9.64905 7.97326H4.92873C4.71878 7.97326 4.54859 7.80306 4.54859 7.59312L4.54857 7.33289ZM19.4248 18.3349H4.16838C3.95843 18.3349 3.78824 18.1647 3.78824 17.9548V9.5186C3.78824 9.30865 3.95844 9.13846 4.16838 9.13846H19.4248C19.6347 9.13846 19.8049 9.30866 19.8049 9.5186V17.9548C19.8049 18.1647 19.6347 18.3349 19.4248 18.3349Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.19 13.3919C17.1076 13.3919 17.854 12.6454 17.854 11.7278C17.854 10.8102 17.1075 10.0637 16.19 10.0637C15.2724 10.0637 14.5259 10.8102 14.5259 11.7278C14.5259 12.6454 15.2724 13.3919 16.19 13.3919ZM16.19 11.2289C16.4651 11.2289 16.6888 11.4527 16.6888 11.7278C16.6888 12.0029 16.465 12.2267 16.19 12.2267C15.9149 12.2267 15.6911 12.0029 15.6911 11.7278C15.6911 11.4527 15.9149 11.2289 16.19 11.2289Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.19 14.218C15.8683 14.218 15.6074 14.4789 15.6074 14.8006V14.8408C15.6074 15.1625 15.8683 15.4234 16.19 15.4234C16.5118 15.4234 16.7726 15.1625 16.7726 14.8408V14.8006C16.7726 14.4789 16.5118 14.218 16.19 14.218Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.19 16.2034C15.8683 16.2034 15.6074 16.4642 15.6074 16.786V16.8261C15.6074 17.1479 15.8683 17.4087 16.19 17.4087C16.5118 17.4087 16.7726 17.1479 16.7726 16.8261V16.786C16.7726 16.4642 16.5118 16.2034 16.19 16.2034Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ToasterIcon;
